/**
 * YouTube動画を1つだけ表示させる
 **/

var ytPlayer = [];
var ytPlaying,ytPlay,ytStop;
function onYouTubeIframeAPIReady() {
    $('.youtube_player').each(function(i){
        // iframe ID を読み込み
        var youtube_id = $(this).attr('id');
        ytPlayer[i] = new YT.Player(youtube_id,{
            events: {
                'onStateChange': function() {
                    var thisState = ytPlayer[i].getPlayerState();

                    if (thisState === 1 && typeof ytPlaying === 'undefined') {
                        ytPlaying = i;
                    } else if (thisState === 1 && ytPlaying !== i) {
                        ytStop = ytPlaying;
                        ytPlay = i;
                    }

                    // 同時再生を感知して停止
                    if (typeof ytStop !== 'undefined' && ytStop !== '') {
                        ytPlayer[ytStop].stopVideo();
                        ytStop = '';
                    }

                    // 再生中のidを保存
                    if (typeof ytPlay !== 'undefined' && ytPlay !== '') {
                        ytPlaying = ytPlay;
                        ytPlay = '';
                    }

                }}
            });
    });
}